<template>
    <div class="pl-column-edit-item" @click="handleClick">
        <keep-alive>
            <link-datepicker
                v-model="showRow[field]"
                v-if="lv_editable"
                :required="lv_required"
                :rules="rules"
                :validate-on-init="validateOnInit"

                type="line"
                color="info"
                shape="none"

                :display-format="displayFormat"
                :value-format="valueFormat"
                :view="view"
                :no-confirm="noConfirm"
                :datetime="datetime"
                :max="max"
                :min="min"

                @change="e=>$emit('change',{row:showRow,value:e,field})"
            />
            <template v-else>
                <link-table-cell-normal
                    :render-func="renderFunc"
                    :scope-slot-func="scopeSlotFunc"
                    :text="showRow[field]"
                    :data="scopeSlotData"/>
            </template>
        </keep-alive>
    </div>
</template>

<script>
    import {ColumnItemMixin} from "../mixins";
    import LvColumnText from "../lv-column-text";
    import LvScopeSlot from "../../render/lv-scope-slot";

    export default {
        name: 'link-table-column-datepicker-item',
        components: {LvScopeSlot, LvColumnText},
        mixins: [ColumnItemMixin],
        props: {
            displayFormat: {type: String,},
            valueFormat: {type: String,},
            view: {default: 'date',},
            noConfirm: {type: Boolean, default: true},
            datetime: {type: Boolean, default: false},
            max: {type: String,},
            min: {type: String,},
        },
    };
</script>
